import type { ApiPaginatedResponse, ApiResponse } from '@bcube/shared';
import { api } from '@/lib/api';
import type { PaymentConfigFormData } from '@/schemas/commercial/payment-config.schema';

export interface PaymentConfig {
  id: string;
  minEntradaPercent: number;
  maxInstallments: number;
  updatedAt: string;
  updatedBy: string;
}

export interface PaymentConfigHistoryEntry {
  id: string;
  configId: string;
  userId: string;
  userName: string;
  changes: { field: string; from: string | number; to: string | number }[];
  createdAt: string;
}

export interface PaymentConfigHistoryParams {
  page?: number;
  limit?: number;
}

export const paymentConfigApi = {
  findCurrent: async (): Promise<PaymentConfig> => {
    const { data } = await api.get<ApiResponse<PaymentConfig>>('/commercial/payment-config');
    return data.data;
  },

  update: async (payload: PaymentConfigFormData): Promise<PaymentConfig> => {
    const { data } = await api.patch<ApiResponse<PaymentConfig>>('/commercial/payment-config', {
      minEntradaPercent: payload.downPaymentPercentage,
      maxInstallments: payload.installments,
    });
    return data.data;
  },

  findHistory: async (
    params?: PaymentConfigHistoryParams,
  ): Promise<{
    docs: PaymentConfigHistoryEntry[];
    total: number;
    pages: number;
    limit: number;
  }> => {
    const { data } = await api.get<ApiPaginatedResponse<PaymentConfigHistoryEntry>>(
      '/commercial/payment-config/audit',
      { params },
    );
    return {
      docs: data.data,
      total: data.meta.total,
      pages: data.meta.pages,
      limit: data.meta.limit,
    };
  },
};
